import { formStyles } from 'components/Form'
import { Form, Formik, FormikConfig } from 'formik'
import React, { ReactNode } from 'react'
import styled, { css } from 'styled-components'

export const formikFormStyles = css`
	${formStyles}

	.formik-form-legend {
		font-size: 1.5rem;
		color: ${props => props.theme.colors.midNeutral.val};
		margin-bottom: 1em;
		display: flex;
		align-items: stretch;
		border-left: solid 3px ${props => props.theme.colors.midNeutral.light(0).val};
		padding-left: 8px;

		${props => props.theme.media.tablet} {
			font-size: 2rem;
		}
	}
`

const FormikFormView = styled.div`
	${formikFormStyles}
`

export type FormikFormProps<T> = Omit<FormikConfig<T>, 'initialValues'> & {
	initialValues: T
	className?: string
	legend?: ReactNode
}
export const FormikForm = ({ children, className, legend, ...props }: FormikFormProps<any>) => {
	return (
		<FormikFormView className={`formik-form${className ? ` ${className}` : ''}`}>
			<Formik {...props} validateOnMount>
				{typeof children === 'function' ? (
					args => (
						<>
							{legend ? <legend className='formik-form-legend'>{legend}</legend> : null}
							{children(args)}
						</>
					)
				) : (
					<Form>
						{legend ? <legend className='formik-form-legend'>{legend}</legend> : null}
						{children}
					</Form>
				)}
			</Formik>
		</FormikFormView>
	)
}
